export class ProjectRequest {
    constructor(public parentProject: string, public projectName: string) {

    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/FineGrainedAuthorization/project-request.ts
 **/